<template>
    <div class="vuetable-filterbar col-md-12">
        <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="cd" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Código</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="descr" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Descrição</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="finalizacao_entrega"
                                     :options="this.$parent.optionsLivFinalizacao"
                                     track-by="value"
                                     label="label"
                                     :hide-selected="true"
                                     placeholder="Finalizou entrega?"
                                     tag-placeholder="Selecionar"
                                     select-label="Selecionar"
                                     selected-label="Selecionado"
                                     deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="reentrega"
                                     :options="this.$parent.optionsReentrega"
                                     track-by="value"
                                     label="label"
                                     :hide-selected="true"
                                     placeholder="Reentrega"
                                     tag-placeholder="Selecionar"
                                     select-label="Selecionar"
                                     selected-label="Selecionado"
                                     deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="status"
                                     :options="this.$parent.optionsLivStatus"
                                     track-by="value"
                                     label="label"
                                     :hide-selected="true"
                                     placeholder="Status"
                                     tag-placeholder="Selecionar"
                                     select-label="Selecionar"
                                     selected-label="Selecionado"
                                     deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="tp_operacao"
                                     :options="this.$parent.optionsTpOperacao"
                                     track-by="value"
                                     label="label"
                                     :hide-selected="true"
                                     placeholder="Tipo Operação"
                                     tag-placeholder="Selecionar"
                                     select-label="Selecionar"
                                     selected-label="Selecionado"
                                     deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="tp_isend"
                                     :options="this.$parent.optionsTpIsend"
                                     track-by="value"
                                     label="label"
                                     :hide-selected="true"
                                     placeholder="Tipo Isend"
                                     tag-placeholder="Selecionar"
                                     select-label="Selecionar"
                                     selected-label="Selecionado"
                                     deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="portal_transp"
                                     :options="this.$parent.optionsPortalTransp"
                                     track-by="value"
                                     label="label"
                                     :hide-selected="true"
                                     placeholder="Portal Transporte"
                                     tag-placeholder="Selecionar"
                                     select-label="Selecionar"
                                     selected-label="Selecionado"
                                     deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="usa_conferencia"
                                     :options="this.$parent.optionsUsaConferencia"
                                     track-by="value"
                                     label="label"
                                     :hide-selected="true"
                                     placeholder="Usa Conferência"
                                     tag-placeholder="Selecionar"
                                     select-label="Selecionar"
                                     selected-label="Selecionado"
                                     deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="exige_tratativa"
                                     :options="this.$parent.optionsExigeTratativa"
                                     track-by="value"
                                     label="label"
                                     :hide-selected="true"
                                     placeholder="Exige Tratativa"
                                     tag-placeholder="Selecionar"
                                     select-label="Selecionar"
                                     selected-label="Selecionado"
                                     deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="tp_processo"
                                     :options="this.$parent.optionsTpProcessos"
                                     track-by="value"
                                     label="label"
                                     :multiple="true"
                                     :hide-selected="true"
                                     placeholder="Tipos de Processos"
                                     tag-placeholder="Selecionar"
                                     select-label="Selecionar"
                                     selected-label="Selecionado"
                                     deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                  <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                    <multiselect v-model="cancela_cte_nstech"
                                 :options="this.$parent.optionsCancelaCteNstech"
                                 track-by="value"
                                 label="label"
                                 :hide-selected="true"
                                 placeholder="Cancela CTe na Nstech"
                                 tag-placeholder="Selecionar"
                                 select-label="Selecionar"
                                 selected-label="Selecionado"
                                 deselect-label="Remover"
                    ></multiselect>
                  </b-col>
                    <b-col sm="6" md="2" class="m-t-5px">
                        <div class="input-group-btn">
                            <div class="btn-group">
                                <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                                <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
  components: {
      Multiselect
  },
  data () {
    return {
        helpForm: new Form({params: []}),
        cd: '',
        descr: '',
        finalizacao_entrega: null,
        reentrega: null,
        status: null,
        tp_operacao: null,
        tp_isend: null,
        portal_transp: null,
        usa_conferencia: null,
        exige_tratativa: null,
        cancela_cte_nstech: null,
        tp_processo: [],
        data_filter: [],
        optionsLivStatus: [],
        optionsLivFinalizacao: [],
        optionsReentrega: [],
        optionsTpOperacao: [],
        optionsTpIsend: [],
        optionsPortalTransp: [],
        optionsUsaConferencia: [],
        optionsExigeTratativa: [],
        optionsTpProcessos: [],
        optionsCancelaCteNstech: [],
    }
  },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.data_filter = {
              cd: this.cd,
              descr: this.descr,
              finalizacao_entrega: this.finalizacao_entrega,
              reentrega: this.reentrega,
              status: this.status,
              tp_operacao: this.tp_operacao,
              tp_isend: this.tp_isend,
              portal_transp: this.portal_transp,
              usa_conferencia: this.usa_conferencia,
              exige_tratativa: this.exige_tratativa,
              tp_processo: this.tp_processo.map(item => item.value),
              cancela_cte_nstech: this.cancela_cte_nstech,
          }
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
        this.cd = '';
        this.descr = '';
        this.finalizacao_entrega = null;
        this.reentrega = null;
        this.status = null;
        this.tp_operacao = null;
        this.tp_isend = null;
        this.portal_transp = null;
        this.usa_conferencia = null;
        this.exige_tratativa = null;
        this.tp_processo = [];
        this.cancela_cte_nstech = null;
        this.$events.fire('filter-reset');
      },
  },
  computed: {
    vuetableFilterButton: {
      get () {
        return this.$store.state.vuetable.filterButton;
      },
    },
  }
}
</script>
